<template>
  <router-link :to="{ name: href }" class="button" :class="typeBt" ref="button" @mouseover.native="runAnimation" @click="$emit('click')">
    <slot></slot>
    <span class="container" ref="container">
      <span class="circle top-left"></span>
      <span class="circle top-left"></span>
      <span class="circle top-left"></span>
      <span class="button__bg"></span>
      <span class="circle bottom-right"></span>
      <span class="circle bottom-right"></span>
      <span class="circle bottom-right"></span>
    </span>
  </router-link>
</template>

<script>
  function getRandom(min, max){
    return Math.random() * (max - min) + min;
  }

  export default {
    props: ['href', 'typeBt'],
    data () {
      return { btTL: undefined }
    },
    mounted () {
      //var bt1 = this.$refs.button;
      var bt1c = this.$refs.container;
      var $circlesTopLeft = bt1c.querySelectorAll('.circle.top-left');
      var $circlesBottomRight = bt1c.querySelectorAll('.circle.bottom-right');

      var filter = document.querySelector('#filter-goo-1 feGaussianBlur');

      var tl = new TimelineLite();
      var tl2 = new TimelineLite();

      this.btTl = new TimelineLite({ 
        paused: true, 
        onUpdate: function() {
          filter.setAttribute('x', 0);
        },
        onComplete: function() {
          bt1c.style.filter = 'none';
        } 
      });

      tl.to($circlesTopLeft, 1.2, { x: -25, y: -25, scaleY: 2, ease: SlowMo.ease.config(0.1, 0.7, false) });
      tl.to($circlesTopLeft[0], 0.1, { scale: 0.2, x: '+=6', y: '-=2' });
      tl.to($circlesTopLeft[1], 0.1, { scaleX: 1, scaleY: 0.8, x: '-=10', y: '-=7' }, '-=0.1');
      tl.to($circlesTopLeft[2], 0.1, { scale: 0.2, x: '-=15', y: '+=6' }, '-=0.1');
      tl.to($circlesTopLeft[0], 1, { scale: 0, x: '-=5', y: '-=15', opacity: 0 });
      tl.to($circlesTopLeft[1], 1, { scaleX: 0.4, scaleY: 0.4, x: '-=10', y: '-=10', opacity: 0 }, '-=1');
      tl.to($circlesTopLeft[2], 1, { scale: 0, x: '-=15', y: '+=5', opacity: 0 }, '-=1');

      var tlBt1 = new TimelineLite();
      var tlBt2 = new TimelineLite();

      tlBt1.set($circlesTopLeft, { x: 0, y: 0, rotation: -45 });
      tlBt1.add(tl);

      tl2.to($circlesBottomRight, 1.2, { x: 25, y: 25, scaleY: 2, ease: SlowMo.ease.config(0.1, 0.7, false) });
      tl2.to($circlesBottomRight[0], 0.1, { scale: 0.2, x: '-=6', y: '+=3' });
      tl2.to($circlesBottomRight[1], 0.1, { scale: 0.8, x: '+=7', y: '+=3' }, '-=0.1');
      tl2.to($circlesBottomRight[2], 0.1, { scale: 0.2, x: '+=15', y: '-=6' }, '-=0.1');
      tl2.to($circlesBottomRight[0], 1, { scale: 0, x: '+=5', y: '+=15', opacity: 0 });
      tl2.to($circlesBottomRight[1], 1, { scale: 0.4, x: '+=7', y: '+=7', opacity: 0 }, '-=1');
      tl2.to($circlesBottomRight[2], 1, { scale: 0, x: '+=15', y: '-=5', opacity: 0 }, '-=1');
      
      tlBt2.set($circlesBottomRight, { x: 0, y: 0, rotation: -45 });
      tlBt2.add(tl2);
    
      this.btTl.add(tlBt1);
      //this.btTl.to(bt1.parentNode.querySelectorAll('.button__bg'), 0.8, { scaleY: 1.1 }, 0.1);
      this.btTl.add(tlBt2, 0.2);
      //this.btTl.to(bt1.parentNode.querySelectorAll('.button__bg'), 1.8, { scale: 1, ease: Elastic.easeOut.config(1.2, 0.4) }, 1.2);
    
      this.btTl.timeScale(2.6);
    },
    methods: {
      runAnimation () {
        this.$refs.container.style.filter = 'url(#filter-goo-1)';
        this.btTl.restart();
      }
    }
  }
</script>

<style scoped lang="scss">
  .button {
    display: inline-block;
    position: relative;
    padding: 15px 30px;
    margin: 10px 20px 10px 0;
    font-size: 18px;
    text-align: center;
    text-decoration: none;
    color: #FFF;
    border-radius: 10px;
    transition: all 0.2s ;
    font-family: 'blogger_sansbold';
    position: relative;
    background: #413492;
    z-index: 0;
    &:hover {
      .circle, .button__bg {
        background: #413492; 
      }
    }

    &.yellow {
      color: #414141;
      background: #e3e039;
      &:hover {
        .circle, .button__bg {
          color: #414141;
          background: #e3e039; 
        }
      }
    }
    &.green {
      background: #4dde44;
      box-shadow: 0px 0px 0px 0px #139a0a;
      &:hover {
        .circle, .button__bg {
          background: #4dde44;
        }
      }
    }
    &.red {
      background: #de2128;
      &:hover {
        .circle, .button__bg {
          background: #de2128;
        }
      }
    }
    &.blue {
      background: #086fab;
      &:hover {
        .circle, .button__bg {
          background: #086fab; 
        }
      }
    }
    
    .container {
      position: absolute;
      display: block;
      width: 200%;
      height: 400%;
      top: -150%;
      left: -50%;
      pointer-events: none;
      z-index: -1;
      -webkit-transform: translateZ(0);
      -moz-transform: translateZ(0);
      -ms-transform: translateZ(0);
      -o-transform: translateZ(0);
      transform: translateZ(0);
      -webkit-transition: all 0.1s ease-out;
      -moz-transition: all 0.1s ease-out;
      transition: all 0.1s ease-out; }
    .button__bg, & .circle {
      -webkit-animation: hue-rotate 10s linear infinite;
      -moz-animation: hue-rotate 10s linear infinite;
      animation: hue-rotate 10s linear infinite; }
    .button__bg {
      position: absolute;
      width: 50%;
      height: 25%;
      top: 50%;
      left: 25%;
      border-radius: 10px;
      -webkit-transform: translateY(-50%);
      -moz-transform: translateY(-50%);
      -ms-transform: translateY(-50%);
      -o-transform: translateY(-50%);
      transform: translateY(-50%); }
    .circle {
      position: absolute;
      width: 25px;
      height: 25px;
      border-radius: 15px;
      -webkit-transition: background-color 0.1s ease-out;
      -moz-transition: background-color 0.1s ease-out;
      transition: background-color 0.1s ease-out; }
    .circle.top-left {
      top: 40%;
      left: 27%; }
    .circle.bottom-right {
      bottom: 40%;
      right: 27%; }
  }
</style>
